"use client";

import { fetchApi } from "@/lib/api-fetch";
import { queryKeys } from "@/lib/query-keys";
import { useQuery } from "@tanstack/react-query";

export interface Profile {
  id: string;
  user_id: string;
  email?: string | null;
  first_name: string | null;
  last_name: string | null;
  created_at: string | null;
  updated_at: string | null;
  slide_credits: number | null;
  stripe_customer_id: string | null;
  credits?: number | null;
  avatar_url?: string | null;
  heard_from?: string | null;
  team_size?: string | null;
  audience_size?: string | null;
  onboarding_completed?: boolean;
  role?: string | null;
  first_handyout_generated_at?: string | null;
  bio?: string | null;
  website?: string | null;
  twitter?: string | null;
  linkedin?: string | null;
  instagram?: string | null;
  use_case?: string | null;
  pain_points?: string[] | null;
  feedback_thank_you_message?: string | null;
}

export function useProfileQuery(options: { includeEmail?: boolean } = {}) {
  const { includeEmail = false } = options;
  return useQuery({
    queryKey: includeEmail
      ? queryKeys.profile.meWithEmail()
      : queryKeys.profile.me(),
    queryFn: () =>
      fetchApi<Profile>(
        includeEmail ? "/api/profiles/me?include_email=true" : "/api/profiles/me",
      ),
  });
}
